import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../hooks/useAuthContext";
import { useConfig } from "../hooks/useConfig";
import { Link } from "react-router-dom";
import Alert from "../components/Alert";

const Tick = () => <span style={{ color: "green" }}>✓</span>;
const Cross = () => <span style={{ color: "red" }}>✗</span>;
const Question = () => <span style={{ color: "blue" }}>?</span>;

const Preencuesta = () => {
  const { user } = useAuthContext();
  const { anio, cuat } = useConfig();
  const [docentesLoading, setDocentesLoading] = useState(true);
  const [docentes, setDocentes] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [alert, setAlert] = useState({
    children: null,
    type: "",
    visible: false,
  });

  useEffect(() => {
    const fetchDocentes = async () => {
      setDocentesLoading(true);
      try {
        const response = await axios.get(
          `/api/admin/horarios-asignados/pre/${anio}/${cuat}`,
          reqHeader,
        );
        const response2 = await axios.get(
          `/api/admin/horarios-asignados/pre/resultados/${anio}/${cuat}`,
          reqHeader,
        );
        setDocentes(response.data);
        setResultados(response2.data);
      } catch (error) {
        showAlert(
          <span>{`Error al cargar los horarios preasignados: ${error.message}`}</span>,
          "error",
        );
      } finally {
        setDocentesLoading(false);
      }
    };
    fetchDocentes();
  }, []);

  const reqHeader = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  };

  const showAlert = (children, type) => {
    setAlert({ children, type, visible: true });
  };

  const closeAlert = () => {
    setAlert({ ...alert, visible: false });
  };

  function extraerContenidoEntreComillas(str) {
    const regex = /"(.*)"/;
    const match = str.match(regex);
    return match ? match[1] : null;
  }

  return (
    <div className="importar-carga-horaria">
      <h3>Docentes con horarios preasignados</h3>
      <div>
        {!docentesLoading &&
          (docentes.length === 0 ? (
            <p>Todavía no se subieron horarios preasignados.</p>
          ) : (
            <ul>
              {docentes.map((d) => {
                const r = resultados.find((r) => r.docente == d.dni);
                return (
                  <li key={`ha-${d.dni}`}>
                    <Link
                      to={`/admin/encuesta/preencuesta/${d.dni}`}
                    >{`${d.apellido}, ${d.nombre}`}</Link>{" "}
                    {r ? r.conservar ? <Tick /> : <Cross /> : <Question />}
                  </li>
                );
              })}
            </ul>
          ))}
      </div>
      {alert.visible && (
        <Alert type={alert.type} onClose={closeAlert}>
          {alert.children}
        </Alert>
      )}
    </div>
  );
};

export default Preencuesta;
